import { createInstructionMarkup, questionComponentPropTypes } from './helpers';

const NoResponseQuestion = ({ question }) => (
  <div className="question text-question">
    <span dangerouslySetInnerHTML={createInstructionMarkup(question)} />
  </div>
);

NoResponseQuestion.propTypes = questionComponentPropTypes;

export default NoResponseQuestion;
